import React from 'react'

import "../app.scss"
import About from '../components/About/About'
import Portfolio from '../components/Portfolio/Portfolio'
import Contact from '../components/Contact/Contact'
import NavBar from '../components/NavBar/NavBar'
import Skills from '../components/Skills/Skills'
import Services from '../components/Services/Services'


//--- translations

import { useTranslation } from 'react-i18next'
import Translation from '../components/Translation/Translation'

export default function Home() {

    const [t, i18n] = useTranslation("global")

    return (
        <>
            <NavBar translation={t} i18n={i18n} />
            <div className="container">
                <About translation={t} i18n={i18n} />
                <Services translation={t} />
                <Skills translation={t} />
                <Portfolio translation={t} />
                <Contact translation={t} />
                <Translation i18n={i18n} />
            </div>
        </>
    )
}
